import React from "react";
import { motion } from "framer-motion";
import {
  FaPrayingHands,
  FaNewspaper,
  FaLightbulb,
  FaMicrophoneAlt,
  FaSchool,
} from "react-icons/fa";

const assemblyActivities = [
  {
    title: "Prayer Session",
    icon: <FaPrayingHands />,
    desc: "The assembly begins with prayer to create positivity and discipline among students.",
  },
  {
    title: "News Reading",
    icon: <FaNewspaper />,
    desc: "National and International news updates help students stay informed and aware.",
  },
  {
    title: "Thought For The Day",
    icon: <FaLightbulb />,
    desc: "Motivational thoughts nourish young minds and inspire students daily.",
  },
  {
    title: "Principal's Address",
    icon: <FaMicrophoneAlt />,
    desc: "Words of wisdom and guidance motivate students towards excellence and values.",
  },
];

const MorningAssembly = () => {
  return (
    <section className="bg-[#f8fbff]">

      {/* HERO */}

      <section className="bg-gradient-to-r from-[#07294d] to-[#0b3d68] py-20">

        <div className="max-w-6xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6 text-white text-4xl">

              <FaSchool />

            </div>

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">

              Cambridge International School

            </p>

            <h1 className="text-5xl md:text-6xl font-black text-white mt-6">

              Morning Assembly

            </h1>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          </motion.div>

        </div>

      </section>

      {/* CONTENT */}

      <section className="max-w-6xl mx-auto px-6 py-16">

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-white rounded-[30px] shadow-xl p-10"
        >

          <h2 className="text-4xl font-black text-[#07294d] mb-6">

            Morning Assembly

          </h2>

          <div className="w-20 h-1 bg-[#d4af37] rounded-full mb-8"></div>

          <p className="text-gray-600 text-lg leading-9">

            School morning assembly is held every day as it marks the
            beginning of the day with an obeisance paid to God. School
            morning assembly can be called the spokesperson of the school.
            The morning assembly is held class wise.

          </p>

          <p className="text-gray-600 text-lg leading-9 mt-6">

            News reading is done to update students about various National
            and International news. The thought for the day nourishes the
            young minds. Students get to know about vital information
            about various topics.

          </p>

          <p className="text-gray-600 text-lg leading-9 mt-6">

            National days and Festivals are celebrated by the House.
            The occasional address by the Principal acts as a great
            motivator for the students and they get enriched by the
            nuggets of wisdom.

          </p>

        </motion.div>

      </section>

      {/* ASSEMBLY ACTIVITIES */}

      <section className="max-w-7xl mx-auto px-6 pb-20">

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">
                    {assemblyActivities.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-[28px] shadow-lg border border-gray-100 p-8 text-center"
            >

              <div className="w-20 h-20 mx-auto rounded-2xl bg-[#07294d]/10 text-[#07294d] flex items-center justify-center text-4xl mb-6">

                {item.icon}

              </div>

              <h3 className="text-2xl font-bold text-[#07294d] mb-5">

                {item.title}

              </h3>

              <div className="w-16 h-1 bg-[#d4af37] rounded-full mx-auto mb-5"></div>

              <p className="text-gray-600 leading-8">

                {item.desc}

              </p>

            </motion.div>

          ))}

        </div>

      </section>

    </section>
  );
};

export default MorningAssembly;